module.exports = __webpack_public_path__ + "img/010.0472007b.jpg";